import React from "react";

const SignatureAnswer = ({ answer, answeres }) => {
  return (
    <div className="answerArea">
      {answeres[answer?.question?._id]?.value === "" ? null : (
        <div
          style={{
            height: 70,
            width: 150,
            border: "1px solid rgba(0, 0, 0, 0.23)",
            padding: "2px",
            borderRadius: "5px",
          }}
        >
          <img
            src={answeres[answer?.question?._id]?.value}
            alt="empoji-path"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </div>
  );
};
export default SignatureAnswer;
